import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaColaboradoresComponent {
  idEmpresa
  idNomina
  nominasNomina
  importar = false
  desconocidos = undefined
  data = undefined
  confirmarBorrar = false
  confirmarDescalcular = false
  actualizando = false
  descalculando = false
  borrando = false
  detallado = false
  calculado = false
  maquilado = false
  cotizado = false
  aprobado = false
  pagado = false
  tipoCambio = 1
  error = null

  constructor ($q, $filter, NominasNominaColaboradores, NominasNomina, NominasNominaStatusCotizado, NominasNominaStatusAprobado, NominasNominaInformacionTipocambio, NominasNominaStatusMaquilado) {
    this.$q = $q
    this.$filter = $filter
    this.NominasNominaColaboradores = NominasNominaColaboradores
    this.NominasNomina = NominasNomina
    this.NominasNominaStatusCotizado = NominasNominaStatusCotizado
    this.NominasNominaStatusAprobado = NominasNominaStatusAprobado
    this.NominasNominaInformacionTipocambio = NominasNominaInformacionTipocambio
    this.NominasNominaStatusMaquilado = NominasNominaStatusMaquilado
  }

  $onInit () {
    this.promise = this.$q.all([
      this.NominasNominaInformacionTipocambio.get(this.idEmpresa, this.idNomina)
        .then(({data}) => (this.tipoCambio = data.tipo_cambio)),
      this.NominasNominaColaboradores.get(this.idEmpresa, this.idNomina)
        .then(({data}) => {
          this.data = data
          this.calculado = this.nominasNomina.data.status_calculado
          this.maquilado = this.nominasNomina.data.status_maquilado
          this.cotizado = this.nominasNomina.data.status_cotizado
          this.aprobado = this.nominasNomina.data.status_aprobado
          this.pagado = this.nominasNomina.data.status_pagado
        }),
    ])
  }

  actualizar (data) {
    this.importar = false
    this.data = data

    this.emitir()
  }

  borrar () {
    this.borrando = true

    return this.NominasNominaColaboradores.delete(this.idEmpresa, this.idNomina)
      .then(() => {
        this.confirmarBorrar = false
        this.calculado = false
        this.data = []

        this.emitir()
      })
      .finally(() => (this.borrando = false))
  }

  descalcular () {
    if (this.maquilado) return

    this.descalculando = true

    return this.NominasNomina.calculado(this.idEmpresa, this.idNomina)
      .then(({data}) => {
        this.calculado = data.status_calculado
        this.nominasNomina.data.status_calculado = this.calculado

        if (!this.calculado) {
          this.data = this.data.filter((item) => !item.cobro_carga_social)
        }

        this.confirmarDescalcular = false
      })
      .finally(() => (this.descalculando = false))
  }

  emitir () {
    this.nominasNomina.nomina.Contiene_Informacion = this.data.length > 0
    this.nominasNomina.nomina.Suministro_Calculado = this.data.reduce((total, item) => total + item.neto, 0)
  }

  maquilar () {
    if (this.cotizado) return

    this.actualizando = true
    this.error = null

    return this.NominasNominaStatusMaquilado.put(this.idEmpresa, this.idNomina, {status_maquilado: !this.maquilado})
      .then(({data}) => {
        this.calculado = this.nominasNomina.data.status_calculado = data.status_calculado
        this.maquilado = this.nominasNomina.data.status_maquilado = data.status_maquilado
        this.cotizado = this.nominasNomina.data.status_cotizado = data.status_cotizado
        this.aprobado = this.nominasNomina.data.status_aprobado = data.status_aprobado
        this.pagado = this.nominasNomina.data.status_pagado = data.status_pagado
        this.timbrado = this.nominasNomina.data.status_timbrado = data.status_timbrado
      })
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }

  cotizar () {
    if (this.aprobado) return

    this.actualizando = true
    this.error = null

    return this.NominasNominaStatusCotizado.put(this.idEmpresa, this.idNomina, {status_cotizado: !this.cotizado})
      .then(({data}) => {
        this.calculado = this.nominasNomina.data.status_calculado = data.status_calculado
        this.maquilado = this.nominasNomina.data.status_maquilado = data.status_maquilado
        this.cotizado = this.nominasNomina.data.status_cotizado = data.status_cotizado
        this.aprobado = this.nominasNomina.data.status_aprobado = data.status_aprobado
        this.pagado = this.nominasNomina.data.status_pagado = data.status_pagado
        this.timbrado = this.nominasNomina.data.status_timbrado = data.status_timbrado
      })
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }

  aprobar () {
    if (this.pagado) return

    this.actualizando = true
    this.error = null

    return this.NominasNominaStatusAprobado.put(this.idEmpresa, this.idNomina, {status_aprobado: !this.aprobado})
      .then(({data}) => {
        this.calculado = this.nominasNomina.data.status_calculado = data.status_calculado
        this.maquilado = this.nominasNomina.data.status_maquilado = data.status_maquilado
        this.cotizado = this.nominasNomina.data.status_cotizado = data.status_cotizado
        this.aprobado = this.nominasNomina.data.status_aprobado = data.status_aprobado
        this.pagado = this.nominasNomina.data.status_pagado = data.status_pagado
        this.timbrado = this.nominasNomina.data.status_timbrado = data.status_timbrado
      })
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }
}

module.component('nominasNominaColaboradores', {
  controller: NominasNominaColaboradoresComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
  },
  require: {
    nominasNomina: '^nomina',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/component.js